import './Welcome.css';

import React, {FC} from 'react';

const Welcome:FC = () => {
   return (
      <div className={'welcome'}>
         <h1 content={'WELCOME'}>
                WELCOME
         </h1>
      </div>
   );
};

export {Welcome};